import { render } from "./AIAgentPanel.vue?vue&type=template&id=5a3c2049&scoped=true"
import script from "./AIAgentPanel.vue?vue&type=script&lang=js"
export * from "./AIAgentPanel.vue?vue&type=script&lang=js"

import "./AIAgentPanel.vue?vue&type=style&index=0&id=5a3c2049&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3c2049"]])

export default __exports__